module.exports = "/fonts/vendor/material-icons/iconmaterial-icons-outlined.woff2?6f420cf17cc0d7676fadeee43b45bd50";